import script from "./DatabaseTableManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseTableManagementView.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseTableManagementView.vue?vue&type=style&index=0&id=5483dbec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5483dbec"]])

export default __exports__